(function() { window.GUID_de5b83e7_e4bd_44de_931a_f0c85d1f8123 = { getGuid: function() { return "de5b83e7-e4bd-44de-931a-f0c85d1f8123"; } }; })();
var CS;
(function (CS) {
    class User {
        User() {
        }
        static CheckIfAnythingToDo(jqXHR) {
            CS.UserHangfireTasks.CheckIfAnyTasks(jqXHR);
            CS.UserDisclaimer.CheckIfAnyDisclaimer(jqXHR);
        }
    }
    CS.User = User;
})(CS || (CS = {}));

//# sourceMappingURL=User.js.map
